const RemovePendingObjectSource = {
    PendingObjectDeleted: 0,
    PendingObjectValidated: 1,
};
export default RemovePendingObjectSource;